﻿import Chart from 'chart.js';
import { sitecore } from '../../Foundation';
import LoyaltyDashboardReport from './components/loyaltyDashboardReport';

export class LoyaltyDashboard {
    /**
    * 
    * @param {HTMLElement} element Video DOM element
    */
    constructor(element) {
        // Name, reference
        element.LoyaltyDashboard = this;

        this._refs = {
            'el': element,
            'graph': element.querySelector('#currentProgress'),
            'items': Array.from(element.querySelectorAll('.loyalty-dashboard__report-section')),
            'foldout': {
                'el': element.querySelector('.loyalty-dashboard__reports'),
                'body': element.querySelector('.loyalty-dashboard__reports-body')
            },
            'action': {
                'toggl': element.querySelector('.loyalty-dashboard__reports-trigger'),
            }
        };

        // # Event bindings, sub-component initialization eg.
        if(this._refs.foldout.el != null) {
            // Toggl
            if(this._refs.action.toggl != null) {
                this._refs.action.toggl.addEventListener('click', this._onReportToggl.bind(this));
            }
        }

        if(this._refs.graph != null) {
            this._onChartInit();
        }

        // # Sub-component initialization
        this._refs.items.forEach(report => new LoyaltyDashboardReport(report, {
            'initiator': this._refs.el,
        }));

        // # Events
        this._refs.el.addEventListener('loyalty.dashboard.update', this._onFoldoutUpdate.bind(this));
    }

    /**
     * Enables toggling of item line content
     * @param {Event} e - Event Interface
     * @todo Remove this since it is not call anywhere
     */ 
    _onReportItemToggl(e) { 
        e.preventDefault();

        const
            oLink = e.target.parentElement,
            oItem = oLink.parentElement.parentElement.parentElement,
            oItemFoldout = oItem.children[oItem.children.length - 1],
            oItemFoldoutInner = oItemFoldout.children[0].offsetHeight;

        if (oItemFoldout.classList.contains('is-visible')) {
            oItemFoldout.style.maxHeight = 0;
            this._refs.reports.body.style.maxHeight = parseInt(this._refs.reports.body.style.maxHeight) - oItemFoldoutInner + 'px';

            oLink.classList.remove('is-active');
            oItemFoldout.classList.remove('is-visible');
        } else {
            oItemFoldout.style.maxHeight = oItemFoldoutInner + 'px';
            this._refs.reports.body.style.maxHeight = parseInt(this._refs.reports.body.style.maxHeight) + oItemFoldoutInner + 'px';

            oLink.classList.add('is-active');
            oItemFoldout.classList.add('is-visible');
        }
    }

    /**
     * Toggl visibility for reports
     * @param {Event} e - Event Interface
     */
    _onReportToggl(e) {
        e.preventDefault();

        if(sitecore.isInPageEditor) {
            return false;
        }

        const intHeight = this._refs.foldout.body.children[0].offsetHeight;

        if (this._refs.foldout.el.classList.contains('is-visible')) {
            this._refs.foldout.body.style.maxHeight = 0;
            this._refs.foldout.el.classList.remove('is-visible');
        } else {
            this._refs.foldout.body.style.maxHeight = intHeight + 'px';
            this._refs.foldout.el.classList.add('is-visible');
        }
    }

    /**
     * Dynamicly update the height of the foldout
     * @param {Event} e - Event interface
     */
    _onFoldoutUpdate (e) {
        switch(e.detail.type) {
            case "addition": 
                this._refs.foldout.body.style.maxHeight = parseInt(this._refs.foldout.body.style.maxHeight) + e.detail.height + 'px';
            break;
            case "subtraction": 
                this._refs.foldout.body.style.maxHeight = parseInt(this._refs.foldout.body.style.maxHeight) - e.detail.height + 'px';
            break;
        }
    }

    /**
     * Initialization of chart for progress chart
     */
    _onChartInit() {
        const
            oData = JSON.parse(this._refs.graph.dataset.sets),
            oConfiguration = {
                type: 'doughnut',
                data: oData,
                options: {
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: this._tooltip
                    },
                    cutout: "80%",
                    circumference: 60 * Math.PI,
                    rotation: -30 * Math.PI
                }
            };

        new Chart(this._refs.graph, oConfiguration);
    }

    /**
     * Base configuration for custom chart tooltip
     * @returns {Object}
     */
    get _tooltip () {
        return { 
            // Disable the on-canvas tooltip
             enabled: false,

             external: function(context) {
                 // Tooltip Element
                 let tooltipEl = document.getElementById('chartjs-tooltip');

                 // Create element on first render
                 if (!tooltipEl) {
                     tooltipEl = document.createElement('div');
                     tooltipEl.id = 'chartjs-tooltip';
                     tooltipEl.innerHTML = '<table></table>';
                     document.body.appendChild(tooltipEl);
                 }

                 // Hide if no tooltip
                 var tooltipModel = context.tooltip;
                 if (tooltipModel.opacity === 0) {
                     tooltipEl.style.opacity = 0;
                     return;
                 }

                 // Set caret Position
                 tooltipEl.classList.remove('above', 'below', 'no-transform');
                 if (tooltipModel.yAlign) {
                     tooltipEl.classList.add(tooltipModel.yAlign);
                 } else {
                     tooltipEl.classList.add('no-transform');
                 }

                 function getBody(bodyItem) {
                     return bodyItem.lines;
                 }

                 // Set Text
                 if (tooltipModel.body) {
                     const 
                         titleLines = tooltipModel.title || [],
                         bodyLines = tooltipModel.body.map(getBody);
                     
                     let innerHtml = '<thead>';

                     titleLines.forEach(function(title) {
                         innerHtml += '<tr><th>' + title + '</th></tr>';
                     });
                     innerHtml += '</thead><tbody>';

                     bodyLines.forEach(function(body, i) {
                         
                         const strBody = body[i].split(':');
                         innerHtml += '<tr><td><span>' + strBody[0] + '</span>'+ strBody[1] +'</td></tr>';
                     });
                     innerHtml += '</tbody>';

                     const tableRoot = tooltipEl.querySelector('table');
                     tableRoot.innerHTML = innerHtml;
                 }

                 const position = context.chart.canvas.getBoundingClientRect();

                 // Display, position, and set styles for font
                 tooltipEl.style.opacity = 1;
                 tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                 tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                 
                 tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
                 tooltipEl.style.pointerEvents = 'none';
             }
         }
    }
}
